
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";



async function loginUser(credentials) {
    // console.log('Sending credentials:', credentials);

    try {
        const response = await fetch('/api/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(credentials),
        });

        if (!response.ok) {
            // Log the error response
            console.error('Server returned an error:', response.status, response.statusText);
            throw new Error(`Login failed: ${response.statusText}`);
        }

        const data = await response.json();
        // console.log('Received response:', data);
        return data;
    } catch (error) {
        console.error('Error during fetch:', error.message);
        throw error;
    }
}
const Login = ({ setToken }) =>{
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false); // New loading state

    const handleSubmit = async e => {
        const login_from = "RiskDesktop";

        // const userIP = await getUserIP();
            setLoading(true);

        try {
            e.preventDefault();
            const token = await loginUser({
                email,
                password,
                login_from
            // }, {
            //     headers: {
            //         'x-forwarded-for': userIP || '',
            //     }
            });
            // console.log('============response==========',token);
            setToken(token);
            // handlePackagelist();

        } catch (err) {
            setError('Invalid username or password');
        } finally {
            setLoading(false);
        }

    };
    return(

        <div className="wrapper" style={{ backgroundColor: '#191717' }}>
        <div className="oxy-video-container" style={{ overflow: 'hidden' }}>
            <video
                autoPlay
                loop
                playsInline
                muted
                style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    minWidth: '100%',
                    minHeight: '100%',
                    width: 'auto',
                    height: 'auto',
                    zIndex:1,
                    transform: 'translate(-50%, -50%)',
                }}
            >
                <source src="/videos/banner_ca.mp4" />
            </video>

            <div
                className="oxy-video-overlay"
                style={{
                    position: 'fixed', // Cover the entire viewport
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.53)', // Semi-transparent black
                    zIndex: 1, // Ensure it is above the video
                }}
            ></div>
        </div>

        <header
            id="header"
            style={{
                position: 'relative',
                zIndex: 2, // Ensure it's above the video and overlay
            }}
        >
            <div className="navless-header">
                <h4 style={{fontWeight: 600}}>Market Risk Desktop</h4>
                <p>Powered By <a href="https://www.contextanalytics-ai.com/" target="_blank" className="underline-link">Context Analytics</a></p>
            </div>

        </header>


        <div className="maincontainer">
            <main id="dashboard-login">
                {/* Dashboard Heading outside the box */}
                <h1 className="login-box-heading">Market Risk Desktop</h1>

                <div className="login-box">
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                    <form onSubmit={handleSubmit}>
                        <div className="form-element">
                            <label>Email address</label>
                            <input type="email"
                                   value={email ||""}
                                   onChange={e => setEmail(e.target.value)}
                                   autoComplete="current-email"
                                   required />
                        </div>
                        <div className="form-element">
                            <label>Password</label>
                            <input type="password"
                                   value={password ||""}
                                   onChange={e => setPassword(e.target.value)}
                                   autoComplete="current-password"
                                   required
                            />
                        </div>
                        <div
                            className="first_form form_element form_fullwidth av-last-visible-form-element"
                            id="element_avia_3_1"
                            style={{
                                display: 'flex', // Use flexbox to align items
                                alignItems: 'center', // Vertically center items
                                justifyContent: 'space-between',
                                marginBottom:'20px',// Push items to the edges
                            }}
                        >
                            <div className="checkbox-holder" style={{ display: 'flex', alignItems: 'center' }}>
                                <input
                                    name="stay_logged_in"
                                    className="input_checkbox"
                                    type="checkbox"
                                    id="stay_logged_in"
                                    value="on"
                                    style={{ marginRight: '5px' }} // Add space between checkbox and label
                                />
                                <label className="input_checkbox_label" htmlFor="stay_logged_in">
                                    Stay logged in
                                </label>
                            </div>

                            {/*<a*/}
                            {/*    style={{*/}
                            {/*        marginLeft: 'auto',*/}
                            {/*        textDecoration: 'none',*/}
                            {/*        color: '#2b97f0',*/}
                            {/*        fontSize: '14px', // Adjust font size for alignment*/}
                            {/*    }}*/}
                            {/*    href="/forgot_password"*/}
                            {/*>*/}
                            {/*    Forgot my password*/}
                            {/*</a>*/}
                        </div>
                        <div className="form_element flex-column">
                            <button className="button Login-btn" id="login" disabled={loading}>
                                {loading ? 'Logging in...' : 'Login'}

                            </button>
                        </div>
                    </form>
                </div>
            </main>
        </div>

    </div>

)
}
Login.propTypes = {
    setToken: PropTypes.func.isRequired,
};

export default Login;